<template>
  <div>
    <Main
      ref="main"
      :loading="loading"
      @reload="getData"
      :tableData="tableGoodsData"
      :disabled="disabled"
      @batchDel="submitDel"
    >
      <Header
        slot="header"
        @showDialog="orderGoodsDialogVisible = true"
        :disabled="disabled"
        @batchDel="batchDel"
      />
    </Main>
    <ChooseOrderGoodsSpecDialog
      :visible.sync="orderGoodsDialogVisible"
      :title="$l('dialog_label_add_order_goods_spec') || '添加订单产品规格'"
      :orderCode="orderCode"
      :type="'checkbox'"
      @confirm="onOrderGoodsConfirm"
      append-to-body
    />
  </div>
</template>
<script>
import Main from './main'
import Header from './header.vue'
import ChooseOrderGoodsSpecDialog from '@/views/factory/components/choose-order-goods-spec/dialog.vue'
import EditLoading from '@/mixins/edit-loading'

export default {
  props: {
    materialCode: { type: String, default: '' },
    orderCode: { type: String, default: '' },
    orderMaterialCode: { type: String, default: '' },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [EditLoading],
  components: { Main, Header, ChooseOrderGoodsSpecDialog },
  data() {
    return {
      tableGoodsData: [],
      loading: false,
      visible: false,
      orderGoodsDialogVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    showDialog() {
      this.visible = true
    },
    //获取产品明细信息
    getData() {
      this.loading = true
      this.$api
        .orderGoodsSpecMaterialListApi({
          materialCode: this.materialCode,
          orderCode: this.orderCode,
        })
        .then((res) => {
          this.loading = false
          this.tableGoodsData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    onOrderGoodsConfirm(data) {
      const orderGoodsSpecMaterialList = data.map((t) => {
        return {
          orderGoodsSpecCode: t.orderGoodsSpecCode,
          orderGoodsCode: t.orderGoodsCode,
        }
      })

      this.loadingOpen()
      this.$api
        .orderGoodsSpecMaterialSaveApi({
          orderGoodsSpecMaterialList: orderGoodsSpecMaterialList,
          orderCode: this.orderCode,
          materialCode: this.materialCode,
          orderMaterialCode: this.orderMaterialCode,
        })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.getData()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    //批量删除的操作
    batchDel() {
      const listCode = this.$refs.main.getCheckboxRecords()
      if (listCode) this.submitDel(listCode)
    },
    submitDel(listCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.$api
            .orderGoodsSpecMaterialDelApi({
              goodsSpecMaterialCodeList: listCode,
            })
            .then(() => {
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
                type: 'success',
              })
              this.getData()
            })
        })
        .catch(() => {})
    },
  },
}
</script>
